export default __webpack_public_path__ + "static/media/white-labelled-solution.ca5470f9.svg";